// Format date to DD-MM-YYYY
export const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date)) return "-";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// Format date for input field (YYYY-MM-DD)
export const normalizeDateForInput = (dateString) => {
  if (!dateString) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return dateString;
  
  const parsed = new Date(dateString);
  if (!isNaN(parsed)) {
    return parsed.toISOString().split('T')[0];
  }
  
  const parts = dateString.match(/^(\d{2})[-\/](\d{2})[-\/](\d{4})$/);
  if (parts) {
    return `${parts[3]}-${parts[2]}-${parts[1]}`;
  }
  
  return "";
};

// Format date for API (DD-MM-YYYY)
export const formatDateForAPI = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

// Truncate text
export const truncateText = (text, maxLength = 15) => {
  if (!text) return "-";
 
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

// Calculate date difference
export const calculateDateDifference = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = end - start;
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

// Render date difference with styling
export const renderDateDifference = (orderDate, dispatchDate, useCurrentDate = false) => {
  const today = new Date();
  const startDate = useCurrentDate ? today : new Date(orderDate);
  const endDate = new Date(dispatchDate);
  if (isNaN(startDate) || isNaN(endDate)) return "-";
  
  const diffDays = calculateDateDifference(startDate, endDate);
  
  if (diffDays >= 0) {
    return (
      <span className="fw-bold" style={{ color: diffDays <= 3 ? "#ffc107" : "#28a745" }}>
        {diffDays} {diffDays === 1 ? "DAY" : "DAYS"} {useCurrentDate ? "LEFT" : ""}
      </span>
    );
  } else {
    return (
      <span className="fw-bold" style={{ color: "#dc3545" }}>
        {Math.abs(diffDays)} {Math.abs(diffDays) === 1 ? "DAY" : "DAYS"} OVERDUE
      </span>
    );
  }
};

// Format image URL
export const formatImageUrl = (url) => {
     
   if (!url) return "";

    // If it's already a complete URL or base64, return as is
    if (
      url.startsWith("http://") ||
      url.startsWith("https://") ||
      url.startsWith("data:")
    ) {
      return url;
    }

    // Clean the URL - remove leading slash
    const cleanUrl = url.startsWith("/") ? url.substring(1) : url;

    // For production, use the /uploads/ path which will be rewritten by .htaccess
    // For local, construct the full URL
    if (window.location.hostname === "new.driftsurface.studio") {
      // On production, just return /uploads/... and let .htaccess handle the rewrite
      if (cleanUrl.startsWith("uploads/")) {
        return `/${cleanUrl}`;
      }
      return `/uploads/${cleanUrl}`;
    }

    // For local development
    return `http://192.168.1.21:5151/${cleanUrl}`;
};

// Extract relative path from full URL
export const extractRelativePath = (url) => {
  if (!url) return url;
  if (!url.includes("http://") && !url.includes("https://")) {
    return url;
  }
  const uploadsIndex = url.indexOf("uploads/");
  if (uploadsIndex !== -1) {
    return url.substring(uploadsIndex);
  }
  return url;
};